import { FC } from "react";
import { Product } from "@prisma/client";
import { useTranslation } from "next-i18next";

import ProductCard from "@components/common/product-card";
import { HITS_PER_PAGE } from "@lib/algolia";
import NavigationButtons from "@components/common/navigation-buttons";

interface Props {
  products: Product[];
  totalNumberOfProducts: number;
  pageNumber: number;
}

const ProductsGrid: FC<Props> = ({
  products,
  pageNumber,
  totalNumberOfProducts,
}) => {
  const { t } = useTranslation("category");

  const prodCount = (pageNumber - 1) * HITS_PER_PAGE + products.length;

  const productsRange = `${
    totalNumberOfProducts > HITS_PER_PAGE
      ? (pageNumber - 1) * HITS_PER_PAGE +
        "-" +
        Math.min(pageNumber * HITS_PER_PAGE, totalNumberOfProducts)
      : prodCount
  }`;

  return (
    <div className="space-y-6">
      <div className="flex flex-wrap justify-center items-center px-10 mx-auto my-8">
        {products.map((product) => (
          <div
            key={product.id}
            className="p-3 w-full sm:w-1/2 md:w-1/4 xl:w-1/6 2xl:w-1/8"
          >
            <ProductCard {...product} />
          </div>
        ))}
      </div>
      <div className="text-center text-black">
        {productsRange} {t("out-of")} {totalNumberOfProducts}
      </div>
      <NavigationButtons
        targetText={t("products")}
        hasNext={totalNumberOfProducts > prodCount}
      />
    </div>
  );
};

export default ProductsGrid;
